// import { GoogleLogin } from 'react-google-login';
import { GoogleLogin } from '@react-oauth/google';
import React, { useState } from 'react';
import TagManager from 'react-gtm-module';

// import { MixPanelSignUpEvents } from '../../../enums/mixpanel-events.enum';
// import { MixPanelChoseSignUpMethodProperties } from '../../../enums/mixpanel-properties.enum';
// import { Mixpanel } from '../../../helpers/mixpanel.helper';
import styles from './GoogleLoginButton.module.scss';

interface GoogleLoginButtonInterface {
  referral_code?: string;
  timezone?: string;
  isSignup?: boolean;
  isJoinWaitlist?: boolean;
  extraParams?: any;
  setError: any;
  callback: any;
  buttonText?: string;
}
const GoogleLoginButton = ({
  buttonText,
  extraParams,
  isJoinWaitlist,
  referral_code,
  isSignup,
  setError,
  timezone,
  callback
}: GoogleLoginButtonInterface): ReactElement => {
  const handleGoogleLogin = async googleData => {
    // Mixpanel.track(MixPanelSignUpEvents.CHOSE_SIGN_UP_METHOD, {
    //   [MixPanelChoseSignUpMethodProperties.METHOD]: SignupMethods.GOOGLE
    // });

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/v2/auth/google`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        token: googleData.credential,
        referral_code: referral_code,
        extraParams,
        isJoinWaitlist
      }),
      withCredentials: true
    });
    try {
      const response = await res.json();
      if (response.status === 422) {
        setError('provider', {
          type: 'manual',
          message: 'You need to use a different login provider.'
        });
      }
      // We want to fire it only when user is creating an account
      // if (isSignUp) {
      //   Mixpanel.track(MixPanelSignUpEvents.COMPLETED_SIGN_UP);

      //   TagManager.dataLayer({
      //     dataLayer: {
      //       event: 'sign_up',
      //       method: 'google',
      //       user_id: res?.data?.user?.id
      //     }
      //   });
      // } else {
      //   TagManager.dataLayer({
      //     dataLayer: {
      //       event: 'login',
      //       method: 'google',
      //       user_id: res?.data?.user?.id
      //     }
      //   });
      // }

      await callback();
    } catch (err) {
      console.error(err);
    }
  };

  const handleError = error => {
    setError({ error });
  };

  // const onButtonClick = () => {
  //   // if (isSignUp) {
  //   //   // Mixpanel.track(MixPanelSignUpEvents.CHOSE_SIGN_UP_METHOD, {
  //   //   //   [MixPanelChoseSignUpMethodProperties.METHOD]: SignupMethods.GOOGLE
  //   //   // });
  //   //   console.log('');
  //   // }
  // };

  return (
    // <div className={styles.container} onClick={onButtonClick}>
    <div className={styles.container}>
      <GoogleLogin
        onSuccess={handleGoogleLogin}
        onError={handleGoogleLogin}
        size={'large'}
        width={'100%'}
        text={isSignup ? 'signup_with' : 'signin_with'}
      />
      {/* <GoogleLogin
        render={renderProps => (
          <button onClick={renderProps.onClick} className={styles.button} disabled={renderProps.disabled}>
            <div className={styles.buttonIcon}>
              <Icon name='google' />
            </div>
            {props.buttonText ? props.buttonText : 'Sign Up with Google'}
          </button>
        )}
        clientId={process.env.REACT_APP_GOOGLE_ID}
        buttonText='Sign In with Google'
        onSuccess={handleGoogleLogin}
        onFailure={handleGoogleLogin}
        cookiePolicy={'single_host_origin'}
      /> */}
    </div>
  );
};

export default GoogleLoginButton;
